<div class="request-details-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ dialogTitle }}</h2>
    <button
      mat-icon-button
      type="button"
      class="close-button"
      aria-label="Close"
      (click)="onCancel()"
      [disabled]="isSubmitting"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    @if (isLoadingInitial) {
      <div class="loading-state">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    } @else if (!isEditMode || initialData) {
      <app-request-wizard-body
        #wizardBody
        [mode]="data.mode"
        [initial]="initialData"
        [isSubmitting]="isSubmitting"
        (submitWizard)="onSubmit($event)"
        (cancel)="onCancel()"
      ></app-request-wizard-body>
    }
  </mat-dialog-content>

  @if (!isEditMode || initialData) {
    <mat-dialog-actions>
      @if ((wizardBody?.stepIndex ?? 0) > 0) {
        <button
          mat-stroked-button
          type="button"
          class="back-button"
          [disabled]="isSubmitting"
          (click)="wizardBody?.back()"
        >
          Back
        </button>
      }
      <span class="dialog-actions-spacer"></span>
      @if (isFinalStep) {
        <button
          mat-raised-button
          type="button"
          class="submit-button"
          [disabled]="isSubmitting"
          (click)="attemptSubmit()"
        >
          {{ submitButtonLabel }}
        </button>
      } @else {
        <div class="split-button" [class.dropdown-open]="showCreateMenu">
          <button
            mat-raised-button
            #primaryOrigin="cdkOverlayOrigin"
            cdkOverlayOrigin
            type="button"
            class="submit-button split-button-primary"
            [disabled]="isSubmitting"
            (click)="wizardBody?.next()"
          >
            {{ nextStepLabel }}
          </button>
          <button
            mat-raised-button
            type="button"
            class="submit-button split-button-arrow"
            [disabled]="isSubmitting"
            (click)="toggleCreateMenu($event)"
            [attr.aria-label]="
              isCreateMode ? 'More create options' : 'More save options'
            "
          >
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </div>

        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="primaryOrigin"
          [cdkConnectedOverlayOpen]="showCreateMenu"
          [cdkConnectedOverlayPositions]="overlayPositions"
          [cdkConnectedOverlayWidth]="splitButtonWidth"
          [cdkConnectedOverlayHasBackdrop]="true"
          cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
          (backdropClick)="showCreateMenu = false"
          (detach)="showCreateMenu = false"
        >
          <div class="create-request-menu">
            <button
              mat-raised-button
              type="button"
              class="submit-button create-request-menu-item"
              [disabled]="isSubmitting"
              (click)="onCreateRequestFromMenu()"
            >
              {{ earlyActionLabel }}
            </button>
          </div>
        </ng-template>
      }
    </mat-dialog-actions>
  }

  @if (isSubmitting) {
    <div class="submit-overlay">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
  }
</div>
